import { initialState as auth } from './reducers/auth';
import { initialState as appliances } from './reducers/appliances';
import { initialState as country } from './reducers/country';
import { initialState as newConfiguration } from './reducers/newConfiguration';
import { initialState as opportunity } from './reducers/opportunity';
import { initialState as configuration } from './reducers/configuration';
import { initialState as admin } from './reducers/admin';
import { initialState as applianceSerialNumber } from './reducers/applianceSerialNumber';

const initial = {
  auth,
  appliances,
  country,
  newConfiguration,
  opportunity,
  configuration,
  admin,
  applianceSerialNumber,
};

export default initial;
